import React from 'react';
import PropTypes from 'prop-types';

import './ModerationDirectLink.scss';
import DirectLinkIcon from '../../../Icons/DirectLinkIcon/DirectLinkIcon';

const ModerationDirectLink = ({ url, closeModal }) => {
    return (
        <a
            href={url}
            rel="noreferrer"
            target="_blank"
            className="component-Community-ModerationMenu-ModerationDirectLink"
            onClick={closeModal}
        >
            <DirectLinkIcon />
            Direct link
        </a>
    );
};

ModerationDirectLink.propTypes = {
    url: PropTypes.string.isRequired,
    closeModal: PropTypes.func,
};

ModerationDirectLink.defaultProps = {
    closeModal: () => {},
};

ModerationDirectLink.displayName = 'ModerationDirectLink';

export default React.memo(ModerationDirectLink);
